export default __webpack_public_path__ + "static/media/leftBackground.5f0edb77.png";